import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import {
  BOARD_ACTIVITY_FILTERS,
  getBoardActivityFilterLabel,
  type BoardActivityFilterValue,
} from '../../utils/board-activity-category';

interface BoardActivityFiltersProps {
  active: BoardActivityFilterValue | null;
  onChange: (value: BoardActivityFilterValue | null) => void;
}

export function BoardActivityFilters({ active, onChange }: BoardActivityFiltersProps) {
  const { t } = useTranslation('tasks');

  return (
    <div
      className="flex items-start gap-2 overflow-x-auto"
      data-testid="tasks-board-activity-filters"
    >
      <button
        type="button"
        onClick={() => onChange(null)}
        className={cn(
          'shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
          active === null
            ? 'bg-primary text-primary-foreground'
            : 'border border-border bg-background text-foreground hover:bg-muted',
        )}
        data-testid="tasks-board-activity-filter-all"
      >
        {t('activity.filters.all')}
      </button>
      {BOARD_ACTIVITY_FILTERS.map((value) => (
        <button
          key={value}
          type="button"
          onClick={() => onChange(value)}
          className={cn(
            'shrink-0 rounded-full px-3 py-1.5 text-xs font-medium transition-colors',
            active === value
              ? 'bg-primary text-primary-foreground'
              : 'border border-border bg-background text-foreground hover:bg-muted',
          )}
          data-testid={`tasks-board-activity-filter-${value}`}
        >
          {getBoardActivityFilterLabel(t, value)}
        </button>
      ))}
    </div>
  );
}
